export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-[640px] mx-auto text-center">
          <span className="text-xs font-label text-primary-400 bg-primary-500/15 px-3 py-1 rounded-full">联系我们</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mt-3">
            投稿与爆料
          </h2>
          <p className="text-sm text-background-400 mt-3 leading-relaxed">
            如果你有娱乐圈、网红圈的最新八卦消息或独家爆料，欢迎通过以下方式联系我们。所有投稿严格保密，吃瓜群众在线等你的一手消息！
          </p>

          <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-900/80 border border-background-800/50">
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
              <div className="flex items-center gap-3 text-background-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/20 text-primary-400">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-xs text-background-500">投稿邮箱</p>
                  <p className="text-sm text-background-200 font-label">tg@chigua51.com</p>
                </div>
              </div>
              <div className="w-px h-10 bg-background-800 hidden sm:block"></div>
              <div className="flex items-center gap-3 text-background-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500/20 text-accent-400">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="text-left">
                  <p className="text-xs text-background-500">微信联系</p>
                  <p className="text-sm text-background-200 font-label">chigua_51</p>
                </div>
              </div>
            </div>

            <p className="mt-6 text-xs text-background-500">
              投稿即表示同意内容授权发布 · 所有爆料信息严格保护来源 · 工作日48小时内回复
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}